import iconHail from '../assets/hail.png'
import iconSnow from '../assets/snow.png'
import iconRain from '../assets/rain.png'
import iconStorm from '../assets/storm.png'
import iconCloud from '../assets/cloud.png'
import iconCloudDay from '../assets/cloudly_day.png'
import iconCloudNight from '../assets/cloudly_night.png'
import iconDay from '../assets/day.png'
import iconNight from '../assets/night.png'

const icons = {
    hail: iconHail,
    snow: iconSnow,
    rain: iconRain,
    storm: iconStorm,
    cloud: iconCloud,
    cloud_day: iconCloudDay,
    cloud_night: iconCloudNight,
    day: iconDay,
    night: iconNight,
}

export default icons